// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"lWlyH":[function(require,module,exports,__globalThis) {
// Navbar interaction logic
var _venetianBlindsJs = require("./venetianBlinds.js");
function setActive(key) {
    // Update bottom navbar links
    const links = document.querySelectorAll('.navbar__link');
    links.forEach((a)=>a.classList.toggle('is-active', a.dataset.nav === key));
    // Update side nav dots
    const dots = document.querySelectorAll('.side-nav__dot');
    dots.forEach((dot)=>dot.classList.toggle('is-active', dot.dataset.section === key));
    // Update navbar state (Primary vs Secondary)
    updateNavbarState(key);
}
function updateNavbarState(key) {
    const navbar = document.querySelector('.navbar');
    if (!navbar) return;
    // Primary state (no background) for 'home' section, Secondary state for all others
    if (key === 'home') navbar.classList.remove('navbar--secondary');
    else navbar.classList.add('navbar--secondary');
}
function initNavbar() {
    const links = document.querySelectorAll('.navbar__link');
    if (!links.length) return;
    links.forEach((a)=>{
        a.addEventListener('click', (e)=>{
            // allow anchor default behavior but update active state
            const key = a.dataset.nav;
            setActive(key);
        });
        a.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setActive(a.dataset.nav);
                a.click();
            }
        });
    });
    // Add click handler for center logo to scroll to top
    const logo = document.querySelector('.navbar__logo');
    if (logo) {
        logo.style.cursor = 'pointer';
        logo.tabIndex = 0; // Make focusable
        logo.addEventListener('click', ()=>{
            if (window.smoothScroll && typeof window.smoothScroll.scrollTo === 'function') window.smoothScroll.scrollTo(0, 800);
            else window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            setActive('home');
        });
        logo.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                logo.click();
            }
        });
    }
    // set active from hash if present
    const hash = location.hash.replace('#', '');
    if (hash) {
        const match = Array.from(links).find((a)=>a.getAttribute('href') === `#${hash}`);
        if (match) setActive(match.dataset.nav);
    } else // Initialize navbar state on page load (starts at home/Primary state)
    updateNavbarState('home');
}
function initSideNav() {
    const dots = document.querySelectorAll('.side-nav__dot');
    if (!dots.length) return;
    dots.forEach((dot)=>{
        dot.addEventListener('click', (e)=>{
            e.preventDefault();
            const section = dot.dataset.section;
            setActive(section);
            // Navigate to the section using smooth scroll
            const target = document.querySelector(`[href="#${section}"]`);
            if (target) target.click();
            else location.hash = section;
        });
        dot.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                dot.click();
            }
        });
    });
}
function initScrollbar() {
    let scrollTimeout;
    let rafPending = false;
    const isTouchLike = window.smoothScroll && window.smoothScroll.isTouchDevice || window.matchMedia && window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    // Get scroll position from smooth scroll or fallback to window
    const getScrollPosition = ()=>{
        // On touch devices, rely on native scrollY (rAF can pause during scroll)
        if (isTouchLike) return window.scrollY;
        if (window.smoothScroll && window.smoothScroll.scrollCurrent !== undefined) return window.smoothScroll.scrollCurrent;
        return window.scrollY;
    };
    const updateScrollingState = ()=>{
        const scrollY = getScrollPosition();
        document.body.classList.add('is-scrolling');
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(()=>{
            document.body.classList.remove('is-scrolling');
        }, 150);
        updateNavbarOnScroll(scrollY);
    };
    // On touch devices, use the native scroll event (rAF loops can stall during scrolling on iOS)
    if (isTouchLike) {
        const onNativeScroll = ()=>{
            if (rafPending) return;
            rafPending = true;
            requestAnimationFrame(()=>{
                rafPending = false;
                updateScrollingState();
            });
        };
        window.addEventListener('scroll', onNativeScroll, {
            passive: true
        });
        // Prime state
        updateScrollingState();
        return;
    }
    // Use requestAnimationFrame to continuously monitor scroll position
    const monitorScroll = ()=>{
        updateScrollingState();
        // Continue monitoring
        requestAnimationFrame(monitorScroll);
    };
    // Start monitoring
    requestAnimationFrame(monitorScroll);
}
function updateNavbarOnScroll(scrollY = null) {
    const navbar = document.querySelector('.navbar');
    if (!navbar) return;
    const heroLogo = document.querySelector('.navbar__logo-hero');
    const smallLogo = document.querySelector('.navbar__logo');
    // Get scroll position from smooth scroll or parameter
    if (scrollY === null) scrollY = window.smoothScroll && window.smoothScroll.scrollCurrent !== undefined ? window.smoothScroll.scrollCurrent : window.scrollY;
    // Calculate which section is currently in view
    const sections = document.querySelectorAll('.content-section');
    const scrollPosition = scrollY + window.innerHeight / 2; // middle of viewport
    let currentSection = 'home'; // default to first section
    let currentSectionIndex = 0;
    sections.forEach((section, index)=>{
        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            currentSectionIndex = index;
            // Map section indices to navigation keys
            // Section 0 -> home (first dot)
            // Sections 1, 2, 3 -> about (second dot)
            // Section 4 -> work (third dot)
            if (index === 0) currentSection = 'home';
            else if (index >= 1 && index <= 3) currentSection = 'about';
            else if (index === 4) currentSection = 'work';
            else currentSection = 'contact';
        }
    });
    // Update navbar visual state based on current section
    // Primary state only for home (section 0)
    if (currentSectionIndex === 0) {
        navbar.classList.remove('navbar--secondary');
        // Force hero-only visibility in home
        if (heroLogo) {
            heroLogo.style.visibility = 'visible';
            heroLogo.style.pointerEvents = 'auto';
        }
        if (smallLogo) {
            smallLogo.style.visibility = 'hidden';
            smallLogo.style.pointerEvents = 'none';
        }
    } else {
        navbar.classList.add('navbar--secondary');
        // Force small-only visibility in other sections
        if (heroLogo) {
            heroLogo.style.visibility = 'hidden';
            heroLogo.style.pointerEvents = 'none';
        }
        if (smallLogo) {
            smallLogo.style.visibility = 'visible';
            smallLogo.style.pointerEvents = 'auto';
        }
    }
    // Update dark overlay and blinds based on simplified spec
    // Overlay schedule (opacity):
    // - Section 1 & 2: 0 on all devices
    // - Section 3: mobile (<=768px) 0.5, otherwise 0 (fade in smoothly)
    // - Section 4: 0.5 on all devices (fade in smoothly from previous)
    // - Section 5: handled by blinds animation; base overlay opacity 0 to avoid stacking with blinds
    // - Section 6: desktop/tablet -> remove black via blinds; mobile (<=768px) -> remain black (overlay 1) throughout
    const darkOverlay = document.getElementById('dark-overlay');
    if (darkOverlay) {
        const isMobile = window.innerWidth <= 768; // per requirement
        // Determine target overlay opacity by section + device
        let overlayOpacity = 0; // default for sections 1-2
        if (currentSectionIndex === 2) // Section 3
        overlayOpacity = isMobile ? 0.7 : 0;
        else if (currentSectionIndex === 3) // Section 4
        // Smooth fade from previous value to 0.5 using CSS transition; set value directly here
        overlayOpacity = 0.7;
        else if (currentSectionIndex === 4) // Section 5 -> use blinds; avoid stacking base overlay with blinds
        overlayOpacity = 0;
        else if (currentSectionIndex === 5) // Section 6
        // Desktop: remove black via blinds opening; Mobile: keep black but via blinds (avoid double-overlay)
        overlayOpacity = 0;
        // Apply overlay visibility and opacity
        if (overlayOpacity > 0) darkOverlay.classList.add('is-visible');
        else darkOverlay.classList.remove('is-visible');
        darkOverlay.style.opacity = overlayOpacity;
        // Blinds logic (section 5 only for desktop/tablet, persistent black in 6 for mobile)
        if (currentSectionIndex === 3) {
            // In section 4 - animate blinds closing as we approach section 5
            const section4 = sections[3];
            const section5 = sections[4];
            if (section4 && section5) {
                const section5Top = section5.offsetTop;
                const transitionWindow = window.innerHeight * 0.35;
                const transitionStart = section5Top - window.innerHeight + transitionWindow - window.innerHeight * 0.016;
                const transitionEnd = section5Top + window.innerHeight * 0.35;
                let blindsProgress = 0;
                if (scrollY >= transitionEnd) blindsProgress = 1;
                else if (scrollY >= transitionStart) blindsProgress = (scrollY - transitionStart) / transitionWindow;
                else blindsProgress = 0;
                (0, _venetianBlindsJs.updateVenetianBlinds)(blindsProgress, {
                    slats: 18,
                    stagger: 0.04,
                    reverse: false
                });
            }
        } else if (currentSectionIndex === 4 || currentSectionIndex === 5) {
            const section6 = sections[5];
            if (section6) {
                if (isMobile) // Mobile: keep blinds closed through section 6 (visually black stays)
                (0, _venetianBlindsJs.updateVenetianBlinds)(1, {
                    slats: 18,
                    stagger: 0.04,
                    reverse: true
                });
                else {
                    // Desktop/tablet: open blinds transitioning into section 6
                    const section6Top = section6.offsetTop;
                    const transitionWindow = window.innerHeight * 0.35;
                    const transitionStart = section6Top - window.innerHeight * 0.5;
                    const transitionEnd = section6Top + window.innerHeight * 0.35;
                    let blindsProgress = 0;
                    if (scrollY >= transitionEnd) blindsProgress = 0;
                    else if (scrollY >= transitionStart) blindsProgress = 1 - (scrollY - transitionStart) / transitionWindow;
                    else blindsProgress = 1;
                    (0, _venetianBlindsJs.updateVenetianBlinds)(blindsProgress, {
                        slats: 18,
                        stagger: 0.04,
                        reverse: true
                    });
                }
            }
        } else // Outside blinds-active sections, hide blinds
        (0, _venetianBlindsJs.resetVenetianBlinds)();
    }
    // Update active states in navigation
    const links = document.querySelectorAll('.navbar__link');
    links.forEach((a)=>a.classList.toggle('is-active', a.dataset.nav === currentSection));
    const dots = document.querySelectorAll('.side-nav__dot');
    dots.forEach((dot)=>dot.classList.toggle('is-active', dot.dataset.section === currentSection));
}
function initContactButton() {
    const contactButton = document.querySelector('.enterprise-buttons button:first-child');
    if (!contactButton) return;
    contactButton.addEventListener('click', ()=>{
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            // Set flag to indicate we arrived via the contact button
            window.__arrivedViaContactButton = true;
            // Reset the clicked state to allow button to show again
            if (window.contactReturnButton) window.contactReturnButton.hasBeenClicked = false;
            const targetPosition = contactSection.offsetTop;
            if (window.smoothScroll && typeof window.smoothScroll.scrollTo === 'function') window.smoothScroll.scrollTo(targetPosition, 1200);
            else window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
            setActive('contact');
        }
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    initNavbar();
    initSideNav();
    initContactButton();
    initScrollbar();
    // Initial check for navbar state on page load
    setTimeout(()=>{
        updateNavbarOnScroll();
    }, 100);
});

},{"./venetianBlinds.js":"iuWxF"}],"iuWxF":[function(require,module,exports,__globalThis) {
// Venetian blinds animation for dark overlay (section 4 -> 5)
// Creates vertical slats that animate based on scroll progress.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateVenetianBlindsOn", ()=>updateVenetianBlindsOn);
parcelHelpers.export(exports, "resetVenetianBlindsOn", ()=>resetVenetianBlindsOn);
parcelHelpers.export(exports, "updateVenetianBlinds", ()=>updateVenetianBlinds);
parcelHelpers.export(exports, "resetVenetianBlinds", ()=>resetVenetianBlinds);
parcelHelpers.export(exports, "withVenetianPageTransition", ()=>withVenetianPageTransition);
var _gsap = require("gsap");
var _gsapDefault = parcelHelpers.interopDefault(_gsap);
// Default config
const DEFAULTS = {
    slats: 18,
    stagger: 0.02
};
const statesByRoot = new WeakMap();
function getState(rootEl) {
    if (!rootEl) return null;
    let state = statesByRoot.get(rootEl);
    if (!state) {
        state = {
            container: null,
            slats: [],
            builtForWidth: 0,
            currentProgress: 0
        };
        statesByRoot.set(rootEl, state);
    }
    return state;
}
function ensureContainer(rootEl, state, opts = {}) {
    if (!rootEl || !state) return null;
    // Rebuild if container missing or viewport size changed significantly
    const needBuild = !state.container || state.builtForWidth !== window.innerWidth;
    if (needBuild) {
        // Clean up any previous
        if (state.container && state.container.parentNode) state.container.parentNode.removeChild(state.container);
        const container = document.createElement('div');
        container.className = 'venetian-blinds';
        container.style.setProperty('--slats-count', String(opts.slats || DEFAULTS.slats));
        // Build slats
        const count = opts.slats || DEFAULTS.slats;
        const slats = [];
        for(let i = 0; i < count; i++){
            const slat = document.createElement('div');
            slat.className = 'venetian-blinds__slat';
            (0, _gsapDefault.default).set(slat, {
                transformOrigin: 'left center',
                scaleX: 0
            });
            container.appendChild(slat);
            slats.push(slat);
        }
        rootEl.appendChild(container);
        state.container = container;
        state.slats = slats;
        state.builtForWidth = window.innerWidth;
    }
    return state.container;
}
function updateVenetianBlindsOn(rootEl, progress, opts = {}) {
    if (!rootEl) return;
    const state = getState(rootEl);
    if (!state) return;
    const mode = opts.mode === 'open' ? 'open' : 'close';
    ensureContainer(rootEl, state, opts);
    if (!state.container) {
        console.warn('updateVenetianBlindsOn: container not created');
        return;
    }
    // Clamp progress to 0-1
    progress = Math.max(0, Math.min(1, progress));
    // Smooth to avoid snaps when section logic switches
    const smooth = typeof opts.smooth === 'number' ? opts.smooth : 0.18;
    const smoothed = state.currentProgress + (progress - state.currentProgress) * smooth;
    if (window.__debugBlinds) console.log('Blinds progress (raw, smooth):', progress, smoothed, 'slats:', state.slats.length);
    // Calculate stagger offset for each slat
    const stagger = opts.stagger ?? DEFAULTS.stagger;
    const reverse = opts.reverse ?? false;
    const numSlats = state.slats.length;
    let maxSlatScale = 0;
    let minSlatScale = 1;
    state.slats.forEach((slat, index)=>{
        const slatIndex = reverse ? numSlats - 1 - index : index;
        const slatStartProgress = slatIndex * stagger;
        let slatProgress = 0;
        if (smoothed >= slatStartProgress) slatProgress = Math.min(1, (smoothed - slatStartProgress) / (1 - slatStartProgress));
        const easedProgress = slatProgress < 0.5 ? 2 * slatProgress * slatProgress : 1 - Math.pow(-2 * slatProgress + 2, 2) / 2;
        // close: 0 -> 1 (slats grow to cover)
        // open:  1 -> 0 (slats shrink away), but still driven by progress 0 -> 1
        const slatScale = mode === 'open' ? 1 - easedProgress : easedProgress;
        (0, _gsapDefault.default).set(slat, {
            scaleX: slatScale
        });
        maxSlatScale = Math.max(maxSlatScale, slatScale);
        minSlatScale = Math.min(minSlatScale, slatScale);
    });
    if (maxSlatScale > 0.01) {
        state.container.style.opacity = '1';
        state.container.style.visibility = 'visible';
    } else {
        state.container.style.opacity = '0';
        state.container.style.visibility = 'hidden';
    }
    const fullyCovered = maxSlatScale > 0.99 && minSlatScale > 0.99;
    rootEl.dataset.blindsCovered = fullyCovered ? '1' : '0';
    rootEl.dataset.blindsProgress = String(smoothed);
    state.currentProgress = smoothed;
}
function resetVenetianBlindsOn(rootEl) {
    if (!rootEl) return;
    const state = getState(rootEl);
    if (!state || !state.container) return;
    (0, _gsapDefault.default).killTweensOf(state.slats);
    state.slats.forEach((slat)=>(0, _gsapDefault.default).set(slat, {
            scaleX: 0
        }));
    state.container.style.opacity = '0';
    state.container.style.visibility = 'hidden';
    state.currentProgress = 0;
}
function updateVenetianBlinds(progress, opts = {}) {
    // Use separate blinds overlay to avoid inheriting dark overlay opacity
    const blindsOverlay = document.getElementById('blinds-overlay');
    if (!blindsOverlay) {
        console.warn('updateVenetianBlinds: blindsOverlay not found');
        return;
    }
    updateVenetianBlindsOn(blindsOverlay, progress, opts);
}
function resetVenetianBlinds() {
    const blindsOverlay = document.getElementById('blinds-overlay');
    if (!blindsOverlay) return;
    resetVenetianBlindsOn(blindsOverlay);
}
const PAGE_TRANSITION_OVERLAY_ID = 'page-transition-overlay';
const PAGE_TRANSITION_LOGO_CLASS = 'page-transition-logo';
const PAGE_TRANSITION_LOGO_READY_KEY = '__pageTransitionLogoReady';
function getLogoAnimUrl() {
    try {
        return new URL(require("c89d8a4042411771")).toString();
    } catch  {
        return 'src/assets/logo_anim.svg';
    }
}
function getLogoMaskUrl() {
    try {
        return new URL(require("10049d6264ea2625")).toString();
    } catch  {
        return 'src/assets/logo_mask.svg';
    }
}
function ensurePageTransitionOverlay() {
    let overlay = document.getElementById(PAGE_TRANSITION_OVERLAY_ID);
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.id = PAGE_TRANSITION_OVERLAY_ID;
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
    return overlay;
}
async function loadSVG(url) {
    const response = await fetch(url);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'image/svg+xml');
    return doc.querySelector('svg');
}
function buildMaskedLogoSvg(logoSvg, maskSvg) {
    if (!logoSvg) return null;
    // Create a unique ID for the mask
    const maskId = 'pt-logo-mask-' + Date.now();
    // Derive mask box from the logo's viewBox to keep coordinates in sync
    const vbVals = (logoSvg.getAttribute('viewBox') || '').trim().split(/\s+/).map(Number);
    const vbX = Number.isFinite(vbVals[0]) ? vbVals[0] : 0;
    const vbY = Number.isFinite(vbVals[1]) ? vbVals[1] : 0;
    const vbW = Number.isFinite(vbVals[2]) ? vbVals[2] : 48;
    const vbH = Number.isFinite(vbVals[3]) ? vbVals[3] : 48;
    const maskElement = document.createElementNS('http://www.w3.org/2000/svg', 'mask');
    maskElement.setAttribute('id', maskId);
    maskElement.setAttribute('maskUnits', 'userSpaceOnUse');
    maskElement.setAttribute('x', String(vbX));
    maskElement.setAttribute('y', String(vbY));
    maskElement.setAttribute('width', String(vbW));
    maskElement.setAttribute('height', String(vbH));
    maskElement.setAttribute('style', 'mask-type:luminance');
    // White background: show everything by default
    const whiteRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    whiteRect.setAttribute('x', String(vbX));
    whiteRect.setAttribute('y', String(vbY));
    whiteRect.setAttribute('width', String(vbW));
    whiteRect.setAttribute('height', String(vbH));
    whiteRect.setAttribute('fill', 'white');
    maskElement.appendChild(whiteRect);
    if (maskSvg) {
        const maskShapes = maskSvg.querySelectorAll('path, rect, circle, ellipse, polygon, polyline');
        maskShapes.forEach((node)=>{
            const cloned = node.cloneNode(true);
            if (!cloned.getAttribute('fill')) cloned.setAttribute('fill', 'black');
            cloned.setAttribute('stroke', 'none');
            maskElement.appendChild(cloned);
        });
    }
    let defs = logoSvg.querySelector('defs');
    if (!defs) {
        defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        logoSvg.insertBefore(defs, logoSvg.firstChild);
    }
    defs.appendChild(maskElement);
    const wrapper = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    wrapper.setAttribute('class', 'masked-logo-content');
    wrapper.setAttribute('mask', `url(#${maskId})`);
    const childrenToWrap = Array.from(logoSvg.childNodes).filter((n)=>n.nodeType === 1 && n.nodeName.toLowerCase() !== 'defs');
    childrenToWrap.forEach((n)=>wrapper.appendChild(n));
    logoSvg.appendChild(wrapper);
    return logoSvg;
}
function resetStrokeDash(paths) {
    Object.values(paths).forEach((path)=>{
        if (!path || typeof path.getTotalLength !== 'function') return;
        const length = path.getTotalLength();
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = length;
    });
}
function buildLogoTimeline(paths, cfg) {
    const tl = (0, _gsapDefault.default).timeline({
        paused: true
    });
    // Mirror startup's ordering and easing; timings will be time-scaled to 1s.
    if (paths.j) tl.to(paths.j, {
        strokeDashoffset: 0,
        duration: cfg.j.duration,
        ease: 'power2.inOut'
    }, cfg.j.delay);
    if (paths.r) tl.to(paths.r, {
        strokeDashoffset: 0,
        duration: cfg.r.duration,
        ease: 'power2.inOut'
    }, cfg.r.delay);
    if (paths.i_dot) tl.to(paths.i_dot, {
        strokeDashoffset: 0,
        duration: cfg.i_dot.duration,
        ease: 'power2.out'
    }, cfg.i_dot.delay);
    if (paths.i_body) tl.to(paths.i_body, {
        strokeDashoffset: 0,
        duration: cfg.i_body.duration,
        ease: 'power2.inOut'
    }, cfg.i_body.delay);
    if (paths.b_upper) tl.to(paths.b_upper, {
        strokeDashoffset: 0,
        duration: cfg.b_upper.duration,
        ease: 'power2.inOut'
    }, cfg.b_upper.delay);
    if (paths.b_lower) tl.to(paths.b_lower, {
        strokeDashoffset: 0,
        duration: cfg.b_lower.duration,
        ease: 'power2.inOut'
    }, cfg.b_lower.delay);
    if (paths.h) tl.to(paths.h, {
        strokeDashoffset: 0,
        duration: cfg.h.duration,
        ease: 'power2.inOut'
    }, cfg.h.delay);
    return tl;
}
async function ensurePageTransitionLogoAnimation(overlay) {
    if (!overlay) return null;
    if (overlay[PAGE_TRANSITION_LOGO_READY_KEY]) return overlay[PAGE_TRANSITION_LOGO_READY_KEY];
    const wrapper = document.createElement('div');
    wrapper.className = PAGE_TRANSITION_LOGO_CLASS;
    overlay.appendChild(wrapper);
    try {
        const [logoSvgRaw, maskSvgRaw] = await Promise.all([
            loadSVG(getLogoAnimUrl()),
            loadSVG(getLogoMaskUrl())
        ]);
        const logoSvg = buildMaskedLogoSvg(logoSvgRaw, maskSvgRaw);
        if (!logoSvg) throw new Error('Logo SVG not loaded');
        logoSvg.removeAttribute('width');
        logoSvg.removeAttribute('height');
        logoSvg.style.cssText = 'display:block; width:100%; height:auto;';
        wrapper.appendChild(logoSvg);
        (0, _gsapDefault.default).set(wrapper, {
            autoAlpha: 1
        });
        (0, _gsapDefault.default).set(logoSvg, {
            autoAlpha: 1
        });
        (0, _gsapDefault.default).set(wrapper, {
            opacity: 1
        });
        (0, _gsapDefault.default).set(logoSvg, {
            opacity: 1
        });
        (0, _gsapDefault.default).set(wrapper, {
            visibility: 'hidden'
        });
        const paths = {
            j: logoSvg.querySelector('#j'),
            r: logoSvg.querySelector('#r'),
            h: logoSvg.querySelector('#h'),
            i_body: logoSvg.querySelector('#i_body'),
            i_dot: logoSvg.querySelector('#i_dot'),
            b_upper: logoSvg.querySelector('#b_upper'),
            b_lower: logoSvg.querySelector('#b_lower')
        };
        resetStrokeDash(paths);
        const cfg = window.LOGO_ANIMATION_CONFIG && window.LOGO_ANIMATION_CONFIG.letters ? window.LOGO_ANIMATION_CONFIG.letters : {
            j: {
                duration: 1.2,
                delay: 0
            },
            r: {
                duration: 1.6,
                delay: 0.2
            },
            i_dot: {
                duration: 0.6,
                delay: 1.0
            },
            i_body: {
                duration: 1.6,
                delay: 0.6
            },
            b_upper: {
                duration: 1.2,
                delay: 0.4
            },
            b_lower: {
                duration: 1.2,
                delay: 0.6
            },
            h: {
                duration: 1.4,
                delay: 0.8
            }
        };
        const tl = buildLogoTimeline(paths, cfg);
        overlay[PAGE_TRANSITION_LOGO_READY_KEY] = {
            wrapper,
            logoSvg,
            paths,
            tl
        };
        return overlay[PAGE_TRANSITION_LOGO_READY_KEY];
    } catch (err) {
        console.warn('Page transition logo animation failed; falling back to hidden logo:', err);
        overlay[PAGE_TRANSITION_LOGO_READY_KEY] = {
            wrapper,
            logoSvg: null,
            paths: null,
            tl: null
        };
        (0, _gsapDefault.default).set(wrapper, {
            autoAlpha: 0,
            visibility: 'hidden'
        });
        return overlay[PAGE_TRANSITION_LOGO_READY_KEY];
    }
}
function wait(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function playTimeline(tl, { direction = 'forward' } = {}) {
    return new Promise((resolve)=>{
        if (!tl) {
            resolve();
            return;
        }
        const done = ()=>{
            tl.eventCallback('onComplete', null);
            tl.eventCallback('onReverseComplete', null);
            resolve();
        };
        if (direction === 'reverse') {
            tl.eventCallback('onReverseComplete', done);
            tl.reverse();
        } else {
            tl.eventCallback('onComplete', done);
            tl.play(0);
        }
    });
}
function tweenBlindsProgress(rootEl, from, to, { duration, ease, slats, stagger, reverse, mode } = {}) {
    return new Promise((resolve)=>{
        const t = {
            p: from
        };
        (0, _gsapDefault.default).to(t, {
            p: to,
            duration: typeof duration === 'number' ? duration : 0.55,
            ease: ease || 'expo.inOut',
            onUpdate: ()=>{
                updateVenetianBlindsOn(rootEl, t.p, {
                    slats: slats ?? DEFAULTS.slats,
                    stagger: stagger ?? 0.04,
                    reverse: !!reverse,
                    mode,
                    smooth: 1
                });
            },
            onComplete: resolve,
            overwrite: true
        });
    });
}
async function withVenetianPageTransition(runSwap, opts = {}) {
    const overlay = ensurePageTransitionOverlay();
    if (!overlay) {
        await Promise.resolve(runSwap?.());
        return;
    }
    const t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    const waitUntilMsFromStart = async (msFromStart)=>{
        const now = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        const elapsed = now - t0;
        const remaining = msFromStart - elapsed;
        if (remaining > 0) await wait(remaining);
    };
    const logoAnim = await ensurePageTransitionLogoAnimation(overlay);
    // Block clicks during the transition.
    overlay.style.pointerEvents = 'auto';
    // Ensure slats exist.
    const transitionState = getState(overlay);
    ensureContainer(overlay, transitionState, {
        slats: opts.slats ?? DEFAULTS.slats
    });
    const container = transitionState?.container;
    const slats = transitionState?.slats || [];
    // Kill any in-flight transition tweens.
    (0, _gsapDefault.default).killTweensOf(slats);
    (0, _gsapDefault.default).killTweensOf(container);
    if (logoAnim?.wrapper) (0, _gsapDefault.default).killTweensOf(logoAnim.wrapper);
    // Timeline-based approach is significantly smoother than manual progress sampling.
    const slatsCount = opts.slats ?? DEFAULTS.slats;
    const staggerEach = typeof opts.stagger === 'number' ? opts.stagger : 0.05;
    const coverDuration = typeof opts.coverDuration === 'number' ? opts.coverDuration : 1.0;
    const revealDuration = typeof opts.revealDuration === 'number' ? opts.revealDuration : 1.1;
    const coverEase = opts.coverEase || 'power4.inOut';
    const revealEase = opts.revealEase || 'power4.inOut';
    const coverFrom = opts.coverReverse ?? false ? 'end' : 'start';
    // Per your requirement: unravel should also go left -> right.
    const revealFrom = opts.revealReverse ?? false ? 'end' : 'start';
    // Overlap controls (seconds). These allow the logo to begin before full cover completes,
    // and allow the reveal to begin before the logo sequence fully finishes.
    const coverLogoOverlap = typeof opts.coverLogoOverlap === 'number' ? opts.coverLogoOverlap : 0.35;
    const logoRevealOverlap = typeof opts.logoRevealOverlap === 'number' ? opts.logoRevealOverlap : 0.60;
    const logoHoldMs = typeof opts.logoHoldMs === 'number' ? opts.logoHoldMs : 300;
    const logoTotalSeconds = 1.0 + logoHoldMs / 1000 + 1.0;
    const logoStartSeconds = Math.max(0, coverDuration - coverLogoOverlap);
    const revealStartSeconds = Math.max(0, logoStartSeconds + logoTotalSeconds - logoRevealOverlap);
    // Always start from a clean visual state.
    if (container) {
        container.style.opacity = '1';
        container.style.visibility = 'visible';
        container.style.setProperty('--slats-count', String(slatsCount));
    }
    (0, _gsapDefault.default).set(slats, {
        transformOrigin: 'left center',
        scaleX: 0
    });
    if (logoAnim?.wrapper) (0, _gsapDefault.default).set(logoAnim.wrapper, {
        autoAlpha: 1,
        visibility: 'hidden'
    });
    const coverPromise = new Promise((resolve)=>{
        (0, _gsapDefault.default).timeline({
            defaults: {
                overwrite: true
            },
            onComplete: resolve
        }).set(slats, {
            transformOrigin: 'left center'
        }, 0).to(slats, {
            scaleX: 1,
            duration: coverDuration,
            ease: coverEase,
            stagger: {
                each: staggerEach,
                from: coverFrom
            }
        }, 0);
    });
    // Logo stroke animation (same as startup): 1s in, hold, 1s out.
    // Starts before cover fully completes for intentional overlap.
    const logoPromise = (async ()=>{
        if (!(logoAnim?.tl && logoAnim?.paths && logoAnim?.wrapper)) return;
        await waitUntilMsFromStart(logoStartSeconds * 1000);
        // Reset + fit total timing to exactly 1s.
        resetStrokeDash(logoAnim.paths);
        logoAnim.tl.pause(0);
        const total = Math.max(0.0001, logoAnim.tl.duration());
        logoAnim.tl.timeScale(total / 1);
        (0, _gsapDefault.default).set(logoAnim.wrapper, {
            visibility: 'visible',
            autoAlpha: 1
        });
        await playTimeline(logoAnim.tl, {
            direction: 'forward'
        });
        await wait(logoHoldMs);
        await playTimeline(logoAnim.tl, {
            direction: 'reverse'
        });
        (0, _gsapDefault.default).set(logoAnim.wrapper, {
            visibility: 'hidden',
            autoAlpha: 0
        });
    })();
    // Start swapping content as soon as we're fully covered.
    const swapPromise = (async ()=>{
        await coverPromise;
        return Promise.resolve(runSwap?.());
    })();
    // Wait for content + the desired reveal start time (for overlap with the logo),
    // then begin revealing.
    const [swapResult] = await Promise.all([
        swapPromise,
        waitUntilMsFromStart(revealStartSeconds * 1000)
    ]);
    await new Promise((resolve)=>{
        const timeline = (0, _gsapDefault.default).timeline({
            defaults: {
                overwrite: true
            },
            onComplete: resolve
        });
        // Start content animation ~800ms into the reveal phase
        if (swapResult?.hero) timeline.to(swapResult.hero, {
            autoAlpha: 1,
            y: 0,
            duration: 1.6,
            ease: 'power2.out'
        }, 1);
        if (swapResult?.main) // Avoid transforming the whole main container (it contains a fixed-position back button).
        timeline.to(swapResult.main, {
            autoAlpha: 1,
            duration: 1.6,
            ease: 'power2.out'
        }, 1.4);
        // Blinds retract animation happens in parallel
        timeline.set(slats, {
            transformOrigin: 'right center'
        }, 0);
        timeline.to(slats, {
            scaleX: 0,
            duration: revealDuration,
            ease: revealEase,
            stagger: {
                each: staggerEach,
                from: revealFrom
            }
        }, 0.06);
        timeline.set(container, {
            opacity: 0,
            visibility: 'hidden'
        });
    });
    // Ensure logo cleanup completes even if it overlaps the reveal.
    await logoPromise;
    overlay.style.pointerEvents = 'none';
    resetVenetianBlindsOn(overlay);
    return swapResult;
}
// Optional: rebuild slats on resize so columns stay even
window.addEventListener('resize', ()=>{
// No-op: `ensureContainer()` will rebuild on the next update because
// it compares `builtForWidth` against `window.innerWidth`.
});

},{"gsap":"kKW9v","c89d8a4042411771":"iOc1K","10049d6264ea2625":"j3Ix6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iOc1K":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("n4Oa8");

},{}],"j3Ix6":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1jfO8");

},{}]},["lWlyH"], "lWlyH", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.788f231b.js.map
